import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { requestUserData } from "../api/api-user";

type UserLevelType = "ineligible" | "base" | "level1" | "level2" | "admin"

export interface UserState {
    status: 'idle' | 'loading' | 'failed',
    uid: number | null,
    level: UserLevelType,
    levelNumber: number,
    discord_username: string
}

const initialState: UserState = {
    status: 'idle',
    uid: null,
    level: "ineligible",
    levelNumber: 0,
    discord_username : ""
}

export const userRequestThunk = createAsyncThunk(
    'main/userRequest', 
    async (uid: number) => {
        const response = await requestUserData(uid);
        return response?.data;
    }
)

export const userReducer = createSlice({
    name: 'main',
    initialState, 
    reducers: {
        updateUID: (state: UserState, action: PayloadAction<number>) => {
            state.uid = action.payload;
        },
        updateLevel: (state: UserState, action: PayloadAction<UserLevelType>) => {
            state.level = action.payload;
        },
        updateDiscordUserName: (state: UserState, action: PayloadAction<string>) => {
            state.discord_username = action.payload;
        }
    }, 
    extraReducers: (builder) => {
        builder
        .addCase(userRequestThunk.pending, (state, action) => {
            state.status = 'loading';
        })
        .addCase(userRequestThunk.fulfilled, (state, action) => {
            if ('user' in action.payload) {
                const nextLevel : UserLevelType = (action.payload.user.feature_levels.is_admin) ? "level2" : // TEMPORARY TOP LEVEL
                    (action.payload.user.feature_levels.is_mcm_pro_preview) ? "level2" : // TEMPORARY TOP LEVEL
                    (action.payload.user.feature_levels.is_premium_2) ? "level2" :
                    (action.payload.user.feature_levels.is_premium_1) ? "level1" :
                    (action.payload.user.level >= 3) ? "base" :
                    "ineligible";
                state.level = nextLevel;
                const nextLevelNumber = (action.payload.user.feature_levels.is_admin) ? 10 : // TEMPORARY TOP LEVEL
                    (action.payload.user.feature_levels.is_mcm_pro_preview) ? 4 :
                    action.payload.user.level;
                state.levelNumber = nextLevelNumber;
                state.discord_username = action.payload.user.discord_username
            }
            state.status = 'idle';
        })
        .addCase(userRequestThunk.rejected, (state) => {
            state.status = 'failed';
        })
    }
})

export const { 
    updateUID,
    updateLevel,
    updateDiscordUserName
} = userReducer.actions;

export const selectStatus = (state: RootState) => state.userData.status;
export const selectUID = (state: RootState) => state.userData.uid;
export const selectLevel = (state: RootState) => state.userData.level;
export const selectDiscordUserName = (state: RootState) => state.userData.discord_username;
export const selectLevelNumber = (state: RootState) => state.userData.levelNumber;

export default userReducer.reducer;